import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IRemoteExplorerService = ( createDecorator('remoteExplorerService'));
export { IRemoteExplorerService };
